var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93797 6.5147C8.00513 5.84166 8.2405 5.19632 8.62245 4.6381C9.00439 4.07987 9.52063 3.6267 10.1236 3.32029C10.7266 3.01388 11.397 2.86408 12.0731 2.88468C12.7492 2.90529 13.4092 3.09563 13.9924 3.43818C14.5756 3.78075 15.0633 4.26451 15.4106 4.84496C15.7578 5.42541 15.9535 6.08388 15.9795 6.75976C16.0055 7.43564 15.8612 8.10721 15.5596 8.71266C15.2637 9.30672 14.8259 9.81839 14.2851 10.2024",
    stroke: "#FD9C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48875 4.88281C9.11276 5.52702 9.85997 6.03915 10.6859 6.38874C11.5119 6.73832 12.3997 6.91822 13.2966 6.91773C14.1787 6.91861 15.052 6.74491 15.8663 6.40688",
    stroke: "#FD9C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0869 9.79688C10.8591 9.79688 10.6364 9.86443 10.447 9.99101C10.2575 10.1176 10.1099 10.2975 10.0227 10.508C9.93554 10.7184 9.91273 10.95 9.95717 11.1734C10.0016 11.3969 10.1113 11.6021 10.2724 11.7632C10.4335 11.9243 10.6387 12.034 10.8622 12.0785C11.0856 12.1228 11.3172 12.1 11.5277 12.0129C11.7382 11.9257 11.918 11.7781 12.0446 11.5886C12.1712 11.3993 12.2387 11.1765 12.2387 10.9487C12.2387 10.6433 12.1174 10.3502 11.9014 10.1342C11.6854 9.91823 11.3924 9.79688 11.0869 9.79688Z",
    stroke: "#FD9C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47948 7.8125V8.6403C6.47948 9.25126 6.72219 9.83722 7.15421 10.2692C7.58624 10.7013 8.17219 10.944 8.78317 10.944H9.87608",
    stroke: "#FD9C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4396 20.1612C19.4396 18.7918 19.0637 17.4487 18.3528 16.2782C17.6447 15.1125 16.6316 14.1626 15.4228 13.5312",
    stroke: "#FD9C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46532 20.1595C4.46516 18.7902 4.84086 17.4472 5.55147 16.2767C6.25853 15.1121 7.27017 14.1628 8.47707 13.5312",
    stroke: "#FD9C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportNav);
export default __webpack_public_path__ + "static/media/support_nav.cb8dc40a36e1d7f63817d6bfa1632857.svg";
export { ForwardRef as ReactComponent };